module.exports = __webpack_public_path__ + "media/images/games/k2gender/swimmer-8ab126ad5ce4351b9d181da6e0cfdd79.png";